export const VENDOR_LOADING = "VENDOR_LOADING";
export const VENDOR_RESET = "VENDOR_RESET";
export const GET_VENDOR = "GET_VENDOR";
export const GET_VENDOR_SUCCESS = "GET_VENDOR_SUCCESS";
export const GET_VENDOR_FAIL = "GET_VENDOR_FAIL";
export const DELETE_VENDOR = "DELETE_VENDOR"
export const DELETE_VENDOR_SUCCESS = "DELETE_VENDOR_SUCCESS"
export const DELETE_VENDOR_FAIL = "DELETE_VENDOR_FAIL"
export const UPDATE_VENDOR = "UPDATE_VENDOR"
export const UPDATE_VENDOR_SUCCESS = "UPDATE_VENDOR_SUCCESS"
export const UPDATE_VENDOR_FAIL = "UPDATE_VENDOR_FAIL"
export const ADD_NEW_VENDOR = "ADD_NEW_VENDOR"
export const ADD_VENDOR_SUCCESS = "ADD_VENDOR_SUCCESS"
export const ADD_VENDOR_FAIL = "ADD_VENDOR_FAIL"
export const VENDOR_RESET_CREATE = "VENDOR_RESET_CREATE"